import { Component, OnInit } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

import { RouterFacade } from '@cigna/core/router-state';
import { FeatureTogglesFacade } from '@cigna/features';

import { AlertItem, ShellFacade } from '@cigna/chcp/shell/data-access';

import keys from 'lodash/keys';
import {
  COOKIE_EXCEPTION_LIST,
  DEEPLINK_BLACKLIST,
} from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  queryParams$ = this.routerFacade.queryParams$;

  loginAlert$ = this.shellFacade.alertPublic$;

  loginAlertStatic: AlertItem = {
    id: 'kbopuk06',
    category: 'Info',
    subcategory: '',
    body: '<a href="https://static.cigna.com/assets/chcp/medical/resourceLibrary/medicalResourcesList/medicalDoingBusinessWithCigna/medicalDbwcCOVID-19.html" target="_blank">Cigna\'s Response to Coronavirus</a><br>Digital ID cards are here. <a href="https://static.cigna.com/assets/chcp/medical/resourceLibrary/medicalResourcesList/medicalDoingBusinessWithCigna/medicalDigitalIDCards.html" target="resourcesWindow">Learn more</a>.',
    header: 'Updated 12/13',
  };

  constructor(
    private routerFacade: RouterFacade,
    private shellFacade: ShellFacade,
    private cookieService: CookieService,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {}

  ngOnInit() {
    this.shellFacade.reset();
    this.shellFacade.loadPublicAlerts();
    this.clearCookies();
    sessionStorage.clear();
  }

  clearCookies() {
    const allCookies: string[] = keys(this.cookieService.getAll());
    const deeplinkCookie: string = this.cookieService.get('CHCP_DEEPLINK');

    allCookies.forEach((cookieName) => {
      if (
        !COOKIE_EXCEPTION_LIST.some((exception) => exception.test(cookieName))
      ) {
        this.cookieService.delete(cookieName, '/');
      }
    });

    if (
      deeplinkCookie &&
      DEEPLINK_BLACKLIST.some((cookie) => cookie === deeplinkCookie)
    ) {
      this.cookieService.delete('CHCP_DEEPLINK', '/');
    }

    // clear analytics login success variable
    localStorage.setItem('adobeLoginSuccess', 'n');
  }
}
